import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';

const useModelCardsTelemedicina = () => {
  const { user, setUser } = useContext(AccountContext);
  const navigate = useNavigate();
  const assinante = userIsSubscriber(user);
  const logado = user.loggedIn === true;

  return {
    navigate,
    assinante,
    logado,
    setUser
  };
};

export default useModelCardsTelemedicina;
